import styled from "styled-components";
import { configService } from '../../services';

export const ImgPlaceholder = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 68.208%;
  background: ${configService.current().colours.GREY_LIGHT};
  border-radius: ${props => props.theme.Base.BorderRadius};
`